export default __webpack_public_path__ + "static/media/masterassassin.5e91323f.png";